<template>
  <div
    class="crop-layer"
    :style="{'z-index': 25}"
    @keydown.stop
  >
    <div
      class="backdrop"
      v-show="isShowLayer"
      :style="{width: Window_Size.width + 'px', height: Window_Size.height + 'px'}"
      ref="backdropEl"
      @mousedown.stop="doCrop()"
    >
      <div
        v-if="sprite"
        class="img-container sprite-mock"
        ref="imgContainerEl"
        :style="spriteMockStyle"
        @mousedown.stop
      >
        <div
          class="inner-ref"
          style="position: absolute; top: 50%; left: 50%; width: 0; height: 0;"
        >
          <div
            class="inner-image"
            style="position: absolute; width: 0; height: 0;"
            :style="{left: ((cropBoxData || {}).deltaX || 0) + 'px', top: ((cropBoxData || {}).deltaY || 0) + 'px'}"
          >
            <img
              class="inner-image-el"
              :src="imageProps.src"
              alt
              ref="imgElView"
              :style="{width: innerImageStyle.width,height: innerImageStyle.height,
                maxWidth: innerImageStyle.width,
                transform: `translate(-50%, -50%) rotate(${(cropBoxData || {}).deltaRotation || 0}deg)`}"
              @dragstart.prevent
            />
            <div
              class="inner-image-mask"
              style="position:absolute; top: 0; left: 0; backgroundColor: rgba(0,0,0,0.5);"
              :style="{
                width: innerImageStyle.width,
                height: innerImageStyle.height,
                maxWidth: innerImageStyle.width,
                transform: `translate(-50%, -50%) rotate(${(cropBoxData || {}).deltaRotation || 0}deg)`
              }"
            ></div>
          </div>
        </div>
      </div>

      <drr
        v-if="isShowCropBox"
        v-bind="cropBox"
        :aspectRatio="true"
        ref="drr"
        @change="onDrr"
        @select="onDrr"
        @drag="onDrrUpdate"
        @resize="onDrrResize"
        @resizestop="hideSizeTip"
        @rotate="onDrrRotate"
        @rotatestop="hideRotationTip"
      >
        <div
          class="crop-box"
          style="position: relative; overflow: hidden; backgroundColor: rgba(255,255,255,0.5); width: 100%; height: 100%;"
        >
          <div
            class="inner-ref"
            style="position: absolute; top: 50%; left: 50%; width: 0; height: 0;"
          >
            <div
              class="inner-image"
              style="position: absolute; width: 0; height: 0;"
              :style="{left: 0 + 'px', top: 0 + 'px', transform: `translate(${cropContentStyles.innerImageLeft}px, ${cropContentStyles.innerImageTop}px)`}"
            >
              <img
                alt
                class="inner-image-el"
                :src="imageProps.src"
                :style="{
                  width: innerImageStyle.width,
                  height: innerImageStyle.height,
                  maxWidth: innerImageStyle.width,
                  transform: sprite.flip
                    ? `translate(-50%, -50%) rotate(${cropContentStyles.innerImageElRotate}deg) scaleX(-1)`
                    : `translate(-50%, -50%) rotate(${cropContentStyles.innerImageElRotate}deg)`
                }"
              />
            </div>
          </div>
        </div>

        <!-- <div
          v-show="sizeTip.isShow"
          class="size-tip"
          style="position: absolute; lineHeight: 30px; height: 30px; left: 0;bottom: 100%;"
        >{{sizeTip.text}}</div>-->
      </drr>

      <div
        v-show="rotationTip.isShow"
        class="rotation-tip"
        style="position: absolute; width: 30px; height: 30px;"
        :style="{top: (cropBoxRect.y - 15) + 'px', left: (cropBoxRect.x - 15) + 'px'}"
      >{{rotationTip.text}}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import VueCropper from '@/plugins/cropper/cropper.vue';
// import getCursor from '@/plugins/cropper/getCursor';
// import getCursorFlipx from '@/plugins/cropper/getCursorFlipx';
import drr from '@/plugins/drr';

/**
 * 计算从x1y1到x2y2的直线，与水平线形成的夹角
 * 计算规则为顺时针从左侧0°到与该直线形成的夹角
 * @param {Object} x1
 * @param {Object} y1
 * @param {Object} x2
 * @param {Object} y2
 */
function getAngle (x1, y1, x2, y2) {
  var x = x1 - x2,
    y = y1 - y2;
  if (!x && !y) {
    return 0;
  }
  var angle = (180 + (Math.atan2(-y, -x) * 180) / Math.PI + 360) % 360;
  return angle;
}

function getRad (deg) {
  return (deg * Math.PI) / 180;
}

function rotate ({ x = 0, y = 0 } = {}, angle) {
  return {
    x: x * Math.cos(angle) - y * Math.sin(angle),
    y: x * Math.sin(angle) + y * Math.cos(angle)
  };
}

const ClipPath = {
  ellipse: 'ellipse(50% 50% at 50% 50%)',
  polygon3: 'polygon(50% 0%, 0% 100%, 100% 100%)',
  polygon4: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);',
  polygon5: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)',
  polygon6: 'polygon(75% 0, 100% 50%, 75% 100%, 25% 100%, 0 50%, 25% 0)',
  trapezium: 'polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%)',
  parallelogram: 'polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%)'
};

const defaultCropBoxData = {
  top: 0,
  left: 0,
  width: 0,
  height: 0,
  originWidth: 0,
  originHeight: 0,
  rotation: 0,
  innerRotation: 0,
  deltaRotation: 0,
  deltaX: 0,
  deltaY: 0
};

export default {
  data () {
    return {
      cropBoxData: {},
      isShowLayer: false,
      sprite: null,
      imageProps: {
        src: '',
        width: '',
        height: '',
        top: '',
        left: ''
      },
      cropBox: {
        x: 0,
        y: 0,
        w: 1,
        h: 1,
        aspectRatio: true,
        selected: true,
        angle: 0,
        innerBound: {
          w: 12,
          h: 12
        }
      },
      spriteRect: {},
      oldStyle: {},
      isShowCropBox: false,
      cropBoxRect: {},
      innerImageRect: {},
      // innerImageStyle: {},
      spriteMockRect: {},
      // spriteMockStyle: {}
      cropContentStyles: {
        innerImageLeft: 0,
        innerImageTop: 0,
        innerImageElRotate: 0
      },
      rotationTip: {
        isShow: false,
        text: ''
      },
      sizeTip: {
        isShow: false,
        text: ''
      },
      fromSvgCrop: false
    };
  },
  computed: {
    ...mapGetters(['Window_Size', 'SelectSprites_Msg', 'TOOL']),
    spriteMockStyle () {
      let sprite = this.sprite;
      let r = this.spriteMockRect;
      let s = {
        width: r.w + 'px',
        height: r.h + 'px',
        left: r.x - r.w / 2 + 'px',
        top: r.y - r.h / 2 + 'px',
        transform: `rotate(${r.angle}deg)`
      };
      if (sprite && sprite.flip) {
        s.transform = `rotate(${r.angle}deg) scaleX(-1)`;
      }
      return s;
    },
    innerImageStyle () {
      let r = this.innerImageRect;
      let s = {
        position: 'absolute',
        width: r.w + 'px',
        height: r.h + 'px',
        left: r.x - r.w / 2 + 'px',
        top: r.y - r.h / 2 + 'px',
        transform: `rotate(${r.angle}deg)`,
        transformOrigin: r.transformOrigin
      };
      return s;
    }
  },
  watch: {
    isShowLayer (val) {
      this.showPopup(val);
      const vm = this;
      const handler = function (ev) {
        vm.onKeydown(ev);
      };
      if (val) {
        $('body').on('keydown', handler);
        $('body').data('keydownHandler', handler);

        vm.sprite.action = 'cropping';
        this.$store.commit('toggle_isPreventDefault', false);
        // vm.$refs.cropper.init();
        this.oldStyle['set-pathAnim'] = $('.set-pathAnim').css('display');
        this.oldStyle['set-free-path'] = $('.set-free-path').css('display');
        $('.set-pathAnim, .set-free-path').hide();
      } else {
        $('body').off('keydown', $('body').data('keydownHandler'));
        $('.set-pathAnim').css({ display: this.oldStyle['set-pathAnim'] });
        $('.set-free-path').css({ display: this.oldStyle['set-free-path'] });
        if (vm.sprite.effect.pathAnim && vm.sprite.effect.pathAnim.target && vm.fromSvgCrop) {
          $('.set-pathAnim').show();
          $('.set-free-path').show();
        }
        this.isShowCropBox = false;

        vm.sprite.action = '';
        this.$store.commit('toggle_isPreventDefault', true);
      }

      this.setSpriteVisibility(val);
    }
  },

  components: {
    drr
  },
  created () {
    const vm = this;
    this.$bus.on('cropImageStart', this.showCropLayer);

    this.$bus.on('cropfreelayer', (flag) => {
      if (flag === false) {
        this.hideCropLayer();
        return;
      }
      this.$analysis({
        category: 'material_setting',
        action: 'click_material_setting_crop',
        label: '素材设置_剪裁'
      });
      this.showCropLayer();
    });

    window.addEventListener('resize', this.hideCropLayer);

    this.$bus.on('cropping.uncrop', () => {
      if (!this.isShowLayer) {
        return;
      }
      this.uncrop();
    });
    this.$bus.on('cropping.confirm', this.doCrop);
    this.$bus.on('cropping.cancel', () => {
      this.isShowLayer = false;
      this.hidePopup();
    });
    this.$bus.on('cropping.select', () => {
      if (this.isShowLayer) {
        this.isShowLayer = false;

        this.$nextTick(() => {
          if (this.sprite.effect.pathAnim && this.sprite.effect.pathAnim.target) {
            $('.set-pathAnim').hide();
            $('.set-free-path').hide();
          }
        })
      }
    });
  },
  mounted () { },
  methods: {
    showCropLayer () {
      const vm = this;
      this.sprite = this.SelectSprites_Msg[0];
      if (!this.sprite) {
        return;
      }
      vm.sprite = vm.SelectSprites_Msg[0];
      defaultCropBoxData.width = defaultCropBoxData.originWidth = vm.sprite.width;
      defaultCropBoxData.height = defaultCropBoxData.originHeight = vm.sprite.height;
      vm.cropBoxData = { ...defaultCropBoxData, ...(vm.sprite.cropBoxData || {}) };
      if (vm.sprite.cropBoxData) {
        let ow = vm.sprite.width / vm.sprite.cropBoxData.width * vm.sprite.cropBoxData.originWidth;
        let oh = vm.sprite.height / vm.sprite.cropBoxData.height * vm.sprite.cropBoxData.originHeight;
        let dx = vm.sprite.width / vm.sprite.cropBoxData.width * vm.sprite.cropBoxData.deltaX;
        let dy = vm.sprite.height / vm.sprite.cropBoxData.height * vm.sprite.cropBoxData.deltaY;
        vm.cropBoxData.originWidth = ow;
        vm.cropBoxData.originHeight = oh;
        vm.cropBoxData.deltaX = dx;
        vm.cropBoxData.deltaY = dy;
      }
      if (vm.sprite.cropType === 'svg') {
        this.handleSvgCrop();
        this.fromSvgCrop = true;
      } else {
        this.fromSvgCrop = false;
      }
      this.$bus.emit('FeaturesPop_close_vue', { type: 3 });
      this.isShowLayer = true;
      this.copySpriteProps();

      this.isShowCropBox = true;
      this.updateCropBox();
      this.setSpriteMockRect();
      this.setInnerImageRect();
    },

    copySpriteProps () {
      const vm = this;
      let sprite = this.SelectSprites_Msg[0];
      let imageSize = this.getImageSize();
      let sourceEl = sprite.ele[0];
      // let rectSourceEl = sourceEl.getBoundingClientRect();
      // let pathAnimEl = $('#app .set-pathAnim .current')[0];
      // if (
      //   $(sourceEl).css('display') === 'none' &&
      //   $(pathAnimEl).css('display') !== 'none'
      // ) {
      //   $(sourceEl).css('display', 'block');
      //   rectSourceEl = sourceEl.getBoundingClientRect();
      // }
      // let currEl = sprite.ele[0];

      let contentRect = this.TOOL.content[0].getBoundingClientRect();

      let trueTL = {
        top: sprite.positionTop + contentRect.top + window.pageYOffset,
        left: sprite.positionLeft + contentRect.left + window.pageXOffset
      };
      let centerPoint = {
        x: trueTL.left + sprite.width / 2,
        y: trueTL.top + sprite.height / 2
      };

      let r = this.TOOL.selectedSprite[0].rotate;
      let scale = this.sprite.flip ? -1 : 1;

      this.imageProps = {
        src: this.$handleAssetsUrl(sprite.option.url),
        width: imageSize.width,
        height: imageSize.height,
        // top: rectSourceEl.top - imageSize.top,
        // left: rectSourceEl.left - imageSize.left,
        transform: `rotate(${r}deg) scalex(${scale})`,
        spriteWidth: sprite.width,
        spriteHeight: sprite.height,
        spriteTop: trueTL.top, // rectSourceEl.top,
        spriteLeft: trueTL.left, // rectSourceEl.left,
        deltaTop: imageSize.top,
        deltaLeft: imageSize.left,
        centerX: centerPoint.x,
        centerY: centerPoint.y
      };
    },

    hideCropLayer () {
      this.isShowLayer = false;
    },

    updateCropBox () {
      let sprite = this.sprite;
      // let centerPoint = this.getCenterPoint(sprite.ele[0]);
      let obj = {};
      obj.w = sprite.width;
      obj.h = sprite.height;
      // obj.x = centerPoint.x;
      // obj.y = centerPoint.y;
      obj.x = this.imageProps.centerX;
      obj.y = this.imageProps.centerY;
      obj.angle = sprite.rotate;
      obj.selected = true;

      this.cropBox = obj;

      this.onDrr(obj);
      this.$nextTick(() => {
        this.onDrrUpdate(obj);
      });
    },

    /**
     * 获取整张图的相关尺寸
     *
     * @returns
     *   top: 截图框相对于整张图的上位移
     *   left: 截图框相对于整张图的左位移
     */
    getImageSize () {
      let sprite = this.SelectSprites_Msg[0] || this.sprite;
      let boxData = this.cropBoxData || defaultCropBoxData || {};
      return {
        width: boxData.originWidth || sprite.width,
        height: boxData.originHeight || sprite.height,
        top: boxData.top || 0,
        left: boxData.left || 0
      };
    },

    /**
     * 以裁剪框中心点建立直角坐标，获取图片中心到坐标原点的x,y距离
     * @param {Object} imgElCenter 图片中心位置
     * @param {Object} cropBoxCenter 裁剪框中心位置
     */
    getDeltaLengths (imgElCenter, cropBoxCenter) {
      let rad1 = Math.atan2(
        imgElCenter.y - cropBoxCenter.y,
        imgElCenter.x - cropBoxCenter.x
      );
      let rad0 = (cropBoxCenter.angle * Math.PI) / 180;
      let rad = rad1 - rad0;
      let deg = (rad * 180) / Math.PI;
      function getC (x, y) {
        return Math.sqrt(x * x + y * y);
      }
      let c = getC(
        imgElCenter.x - cropBoxCenter.x,
        imgElCenter.y - cropBoxCenter.y
      );
      let dx = c * Math.cos(rad);
      let dy = c * Math.sin(rad);

      return {
        deltaX: dx,
        deltaY: dy
      };
    },

    doCrop () {
      if (!this.isShowLayer) {
        return;
      }
      let sprite = this.SelectSprites_Msg[0];
      let imageSize = this.getImageSize();

      let currEl = this.$refs.imgElView;
      let imgElCenter = this.getCenterPoint(currEl);

      let vector = rotate({
        x: imgElCenter.x - this.cropBoxRect.x,
        y: imgElCenter.y - this.cropBoxRect.y
      }, getRad(-this.cropBoxRect.angle));
      let dx = vector.x;
      let dy = vector.y;

      let cropBoxData = {
        top: 0,
        left: 0,
        width: this.cropBoxRect.w,
        height: this.cropBoxRect.h,
        rotation: this.cropBoxRect.angle,
        innerRotation: this.innerImageRect.angle,
        deltaRotation: this.innerImageRect.angle - this.cropBoxRect.angle,
        deltaX: dx,
        deltaY: dy
      };
      if (sprite.flip) {
        cropBoxData.deltaX *= -1;
        cropBoxData.deltaRotation *= -1;
      }
      cropBoxData.originWidth = imageSize.width;
      cropBoxData.originHeight = imageSize.height;
      cropBoxData.deltaRotation %= 360;
      if (cropBoxData.deltaRotation > 180) {
        cropBoxData.deltaRotation -= 360;
      }
      if (cropBoxData.deltaRotation <= -180) {
        cropBoxData.deltaRotation += 360;
      }

      this.$nextTick(() => {
        if (sprite.cropType === 'svg') {
          let imgUrl = sprite.option.url;
          let svg = sprite.ele.find('svg');
          let img = $('<img>').appendTo(sprite.ele);
          img[0].src = this.$handleAssetsUrl(imgUrl);
          img[0].style = (svg[0] || {}).style;
          svg.remove();
          let uuid = sprite.id;
          $(`#player-sprite-${uuid}`).find('svg').remove();
        }
        this.setSpriteVisibility(false);
        let moveEl = this.$refs.drr.$el;
        let rect = moveEl.getBoundingClientRect();
        let contentRect = this.TOOL.content[0].getBoundingClientRect();
        let c1 = this.getCenterPointByRect(rect);
        cropBoxData.left = (c1.x - cropBoxData.width / 2) - contentRect.left;
        cropBoxData.top = (c1.y - cropBoxData.height / 2) - contentRect.top;
        sprite.setCropBoxData(cropBoxData, {
          rect,
          undo: true,
          croppedFlag: true,
          cropType: 'free'
        });

        this.$bus.emit('updateEffect_vue', { type: 'path' });
        this.isShowLayer = false;
        this.hidePopup();

        this.$analysis(
          'material_setting_panel,click_rotate_crop,素材设置_设置面板_裁剪_旋转'
        );
      });
    },

    uncrop () {
      let sprite = this.SelectSprites_Msg[0];
      let imageSize = this.getImageSize();
      $(this.$el).find('.inner-image > .inner-image-el')
      let rect = (this.$refs.imgElView || $(this.$el).find('.inner-image > .inner-image-el')[0]).getBoundingClientRect();
      let contentRect = this.TOOL.content[0].getBoundingClientRect();
      let c1 = this.getCenterPointByRect(rect);
      sprite.cancelCrop({
        width: imageSize.width,
        height: imageSize.height,
        positionLeft: (c1.x - imageSize.width / 2) - contentRect.left,
        positionTop: (c1.y - imageSize.height / 2) - contentRect.top,
        rotation: this.innerImageRect.angle
      }, true);

      this.setSpriteVisibility(true);
      this.$bus.emit('updateEffect_vue', { type: 'path' });
      this.isShowLayer = false;
      this.hidePopup();
    },

    onKeydown (ev) {
      // 27 esc
      // 8 backspace
      // 46 delete
      if (ev.keyCode === 27 || ev.keyCode === 8 || ev.keyCode === 46) {
        this.isShowLayer = false;
        this.hidePopup();
      }
      if (ev.keyCode === 13) {
        // enter
        this.doCrop();
      }
    },

    setSpriteVisibility (isMaskShow) {
      let flag = isMaskShow;
      let sprite = this.SelectSprites_Msg[0];
      sprite.ele.css({ visibility: flag ? 'hidden' : 'visible' });
      sprite.opHelper.el.css({ visibility: flag ? 'hidden' : 'visible' });
      // hide spriteBtn
      this.$bus.emit('settingPopup.toggle', flag);
    },

    // modifyCursor () {
    //   let points = $('.crop-layer .cropper-point');
    //   let lines = $('.crop-layer .cropper-line');
    //   let rotation = this.sprite.rotate;
    //   let myGetCursor = this.sprite.flip ? getCursorFlipx : getCursor;
    //   let isFlip = this.sprite.flip;
    //   points.each((i, el) => {
    //     let direction = el.dataset.cropperAction;
    //     let modCursor = myGetCursor(rotation, direction);
    //     let filtered = lines.filter((i, el) => el.dataset.cropperAction === direction)
    //     $(el).add(filtered[0]).css({
    //       cursor: `${modCursor}-resize`
    //     });
    //   })
    // },

    onDrr (rect) {
      this.cropBoxRect = rect;
      // console.log(rect)
    },

    onDrrUpdate (rect) {
      this.updateCropBoxContent(rect);
    },

    onDrrRotate (rect) {
      let r = rect.angle;
      let base =
        (this.cropBoxData || defaultCropBoxData).deltaRotation + this.spriteMockRect.angle;
      let counting = ((r - base) / 45) | 0;
      let k = Math.abs(r - base) % 45;
      let stickyR = counting * 45 + base;
      if (k < 5) {
        this.$refs.drr.rotation = stickyR;
        this.updateCropBoxContent({ ...rect, angle: stickyR });
        this.updateRotationTip({ ...rect, angle: stickyR });
      } else {
        this.updateCropBoxContent(rect);
        this.updateRotationTip(rect);
      }
    },

    onDrrResize (rect) {
      this.updateCropBoxContent(rect);
      // this.updateSizeTip(rect);
    },

    updateCropBoxContent (rect) {
      if (!this.$refs.drr) {
        return;
      }
      let imgEl = this.$refs.imgElView;
      let imgElCenter = this.getCenterPoint(imgEl);
      let { deltaX, deltaY } = this.getDeltaLengths(imgElCenter, rect);

      // let drrEl = this.$refs.drr.$el;
      // $(drrEl).find('.inner-image').css({
      //   left: (deltaX || 0) + 'px',
      //   top: (deltaY || 0) + 'px'
      // });

      this.cropContentStyles = {
        cropBoxWidth: rect.w,
        cropBoxHeight: rect.h,
        innerImageLeft: deltaX,
        innerImageTop: deltaY,
        innerImageElRotate: this.innerImageRect.angle - rect.angle
      };

      // $(drrEl).find('.inner-image-el').css({
      //   transform: `translate(-50%, -50%) rotate(${this.innerImageRect.angle - rect.angle}deg)`
      // })
    },

    getImagePosition () {
      let size = this.getImageSize();
      let x = size.left + this.imageProps.spriteWidth / 2;
      let y = size.top + this.imageProps.spriteHeight / 2;
      let transformOrigin = `${x}px ${y}px`;
      return {
        transformOrigin,
        translateX: -size.left,
        translateY: -size.top
      };
    },

    getCenterPoint (el) {
      let rect = el.getBoundingClientRect();
      let c = {
        x: rect.left + rect.width / 2 + window.pageXOffset,
        y: rect.top + rect.height / 2 + window.pageYOffset
      };
      return c;
    },

    setSpriteMockRect (r) {
      let sprite = this.sprite;
      // let centerPoint = this.getCenterPoint(sprite.ele[0]);
      r = {};
      r.w = sprite.width;
      r.h = sprite.height;
      // r.x = centerPoint.x;
      // r.y = centerPoint.y;
      r.x = this.imageProps.centerX;
      r.y = this.imageProps.centerY;
      r.angle = sprite.rotate;
      this.spriteMockRect = r;
    },

    setInnerImageRect (r) {
      let imageProps = this.imageProps;
      let sprite = this.sprite;
      let cropBoxData = this.cropBoxData || defaultCropBoxData || {};
      // let centerPoint = this.getCenterPoint(sprite.ele[0]);
      r = {};
      r.w = imageProps.width;
      r.h = imageProps.height;
      r.x = this.imageProps.centerX + (cropBoxData.deltaX || 0);
      r.y = this.imageProps.centerY + (cropBoxData.deltaY || 0);

      let flipx = sprite.flip ? -1 : 1;
      r.angle =
        (cropBoxData.deltaRotation * flipx || 0) +
        this.spriteMockRect.angle;
      if (cropBoxData.deltaRotation % 360 > 1) {
        // r.transformOrigin = `${cropBoxData.left + cropBoxData.width / 2}px ${cropBoxData.top + cropBoxData.height / 2}px`
        r.transformOrigin = `0 0`;
      } else {
        r.transformOrigin = `center center`;
      }
      this.innerImageRect = r;
    },

    updateRotationTip (rect, flag = true) {
      let angle = Math.round(rect.angle);
      if (angle < 0) {
        angle += 360;
      }
      this.rotationTip = {
        isShow: flag,
        text: `${angle}°`
      };
    },

    hideRotationTip (rect) {
      this.updateRotationTip(rect, false);
    },

    updateSizeTip (rect, isShow = true) {
      let w = Math.round(rect.w);
      let h = Math.round(rect.h);
      this.sizeTip = {
        isShow,
        text: `${w} × ${h}`
      };
    },

    hideSizeTip (rect) {
      this.updateSizeTip(rect, false);
    },

    showPopup (flag = true) {
      if (flag === false) {
        return;
      }
      let sourceEl = this.sprite.ele[0];
      let rectSourceEl = sourceEl.getBoundingClientRect();
    },
    hidePopup () {
      this.$bus.emit('FeaturesPop_close_vue', {
        name: 'cropping',
        type: 1,
      });
    },
    handleSvgCrop () {
      this.cropBoxData = this.getCropDataFromSvgCrop();
    },
    getCropDataFromSvgCrop () {
      let boxData = this.sprite.cropBoxData;
      let info = this.getSvgCropInfo();
      let v1 = { x: -info.w / 2, y: -info.h / 2 };
      let v2 = { x: info.dx, y: info.dy };
      let v3 = { x: info.ow / 2, y: info.oh / 2 }
      let vt = { x: v1.x + v2.x + v3.x, y: v1.y + v2.y + v3.y };
      return {
        ...this.cropBoxData,
        deltaX: vt.x,
        deltaY: vt.y,
        originWidth: info.ow,
        originHeight: info.oh,
        width: info.w,
        height: info.h,
        rotation: boxData.rotate,
        innerRotation: boxData.rotate,
        deltaRotation: 0
      }
    },
    getSvgCropInfo () {
      let boxData = this.sprite.cropBoxData;
      let rW = this.sprite.width / boxData.width;
      let rH = this.sprite.height / boxData.height;
      let info = {};
      info.ow = boxData.originWidth * rW;
      info.oh = boxData.originHeight * rH;
      info.w = this.sprite.width;
      info.h = this.sprite.height;
      info.dx = boxData.deltaX * rW;
      info.dy = boxData.deltaY * rH;
      return info;
    },
    getCenterPointByRect (rect) {
      return {
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2,
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.crop-layer {
  position: absolute;
  top: 0;
  left: 0;
}
.backdrop {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(248, 248, 248, 0.75);
}
.img-container {
  position: absolute;
}

.rotation-tip {
  border: 1px white solid;
  border-radius: 50%;
  color: white;
  background-color: rgba(#000, 0.5);
  line-height: 30px;
  text-align: center;
  font-size: 12px;
}
.size-tip {
  color: white;
  background-color: rgba(#000, 0.5);
  padding-left: 8px;
  padding-right: 8px;
  min-width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/CropLayer.vue